import FormValidationService from '../Service/FormValidationService'

const formValidationService = new FormValidationService()
formValidationService.init()
